import React from 'react';

import Breed from 'services/Breed';
import { registrationRequestDefaultSearchState } from 'services/constants';

import AbstractSearchForm from 'components/AbstractSearchForm';
import Autocomplete       from 'components/autocomplete';
import AutocompleteAsync from 'components/AutocompleteAsync';
import DatePickerInput from 'components/DatePickerInput';

export default class RegRequestSearchForm extends AbstractSearchForm {

  constructor(props) {
    super(props);
    this.state.breeds = [];
    this.defaultSearchState = registrationRequestDefaultSearchState;
  }

  getSeachData() {
    Breed.query().then(({items: breeds}) => {
      if (this.mounted) {
        this.setState( { breeds } );
      }
    });
  }

  render() {
    const item = this.state.item;
    if (Object.keys(item).length < 1) return null;
    return (
      <form onSubmit={this.onSubmit} className="col-lg-12 border p-3 rounded">
        <div className="row">
          <div className="col-sm-4 mb-3">
            <label htmlFor="breed_id">Порода</label>
            <Autocomplete items={this.state.breeds} name="breed_id" value={item.breed_id} 
            valueProp="id" labelValue="name" onChange={this.propertyChanged} />
          </div>
          <div className="col-sm-4">
            <label htmlFor="name">Кличка</label>
            <AutocompleteAsync 
              modelName="dog" name="name" value={item.name} 
              onChange={this.propertyChanged} />
          </div>

          <div className="col-sm-4">
            <label htmlFor="pedigree">Родословная</label>
            <AutocompleteAsync 
              modelName="dog" name="pedigree" value={item.pedigree} 
              onChange={this.propertyChanged} />
          </div>
          <div className="col-sm-2 mb-3">
            <label htmlFor="country_id">Дата рождения</label>
            <div>
              <DatePickerInput
                selected={item.date_of_birth}
                name="date_of_birth"
                onChange={this.propertyChanged}
              />
            </div>
          </div>
          {item && item.hasOwnProperty('need_catalog') ? (
          <div className="col-sm-1" key="need_catalog">
            <label htmlFor="need_catalog">
              Нужен каталог
            </label>
            <label htmlFor="need_catalog">
                <input className="m-2" type="checkbox" name="need_catalog" id="need_catalog"
                checked={item.need_catalog} onChange={this.propertyChanged} />
                Да
              </label>
          </div>)
         : null}
          <div className="col-sm-1 ms-4">
            <label style={{width:'100%'}}>&nbsp;</label>
            <button type="submit" className="btn btn-primary">Искать</button>
          </div>
          <div className="col-sm-1">
            <label style={{width:'100%'}}>&nbsp;</label>
            <button onClick={this.clear} type="button" className="btn btn-default">Очистить</button>
          </div>
        </div>
      </form>
    )
  }
}
